import { healthInsurance } from './healthInsurance';
import { paymentStatus } from './paymentStatus';
import { privatePayment } from './privatePayment';

const paymentRoutes = [
  ...paymentStatus,
  ...privatePayment,
  ...healthInsurance
];

export default paymentRoutes;
